import { ChevronRight } from '@aktiia/design-system';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FetchStatus } from '../../../../enums';
import {
  useOrganization,
  useOrganizationUsersTableHeaders,
  useOrganizationUsersTableRows,
} from '../../../../features/organization';
import { Button, Card } from '../../../common';
import { Table } from '../../table';
import { NoUsers, OrganizationUsersHeader } from './components';
import { IOrganizationUsersProps } from './types';

export const OrganizationUsers = ({ expanded }: IOrganizationUsersProps) => {
  const { t } = useTranslation();
  const {
    status: { fetchUsers: status },
  } = useOrganization();
  const deviceRows = useOrganizationUsersTableRows(!expanded);
  const header = useOrganizationUsersTableHeaders(expanded);
  const loaded = useMemo(() => [FetchStatus.SUCCESS, FetchStatus.FAILURE].includes(status), [status]);

  return (
    <Card>
      <div className="mb-6">
        <OrganizationUsersHeader expanded={expanded} />
        {expanded && (
          <p className="typography-paragraph-3 text-text-secondary mt-2">{t('organization.subtitle.users')}</p>
        )}
      </div>

      {loaded && !deviceRows.length ? (
        <NoUsers expanded={expanded} />
      ) : (
        <Table rows={deviceRows} header={header} loading={!loaded} />
      )}

      <div className="grow" />
      <div className="mt-6">
        {!expanded && (
          <Button
            text={t('organization.button.users')}
            path="/app/organization/users"
            rightIcon={<ChevronRight />}
            type="tertiary"
          />
        )}
      </div>
    </Card>
  );
};
